import React, { useState } from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

interface IPasswordFieldProps {
  id: string;
  label: string;
  onChange: (value: string) => void;
  error: boolean;
  helperText: string;
}

const PasswordField: React.FC<IPasswordFieldProps> = ({
  id,
  label,
  onChange,
  error,
  helperText
}) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setPassword(value);
    onChange(value);
  };

  const toggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextField
      id={id}
      label={label}
      variant="filled"
      fullWidth
      type={showPassword ? "text" : "password"}
      value={password}
      onChange={handleChange}
      autoComplete="new-password"
      error={error}
      helperText={helperText}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={toggleVisibility}
              edge="end"
              aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
              title={showPassword ? "Esconder senha" : "Mostrar senha"}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};

export default PasswordField;
